import { render, staticRenderFns } from "./FormHeadE.vue?vue&type=template&id=4bb8c4dc&scoped=true"
import script from "./FormHeadE.vue?vue&type=script&lang=js"
export * from "./FormHeadE.vue?vue&type=script&lang=js"
import style0 from "./FormHeadE.vue?vue&type=style&index=0&id=4bb8c4dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb8c4dc",
  null
  
)

export default component.exports